import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaLinkedin, FaInstagram, FaXTwitter } from "react-icons/fa6";

export default function Footer() {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    if (path === "/features") {
      return currentPath.startsWith("/features");
    }
    return currentPath === path;
  };

  const getLinkClass = (path) => {
    return isActive(path)
      ? "text-brand-orange font-semibold transition-colors"
      : "hover:text-brand-orange transition-colors";
  };

  return (
    <footer className="py-16 border-t border-border-theme bg-bg-secondary/30 relative z-10 text-left">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 flex flex-col gap-4">
          <Link to="/" className="flex items-center select-none w-fit">
            <img src="/logo.png" alt="Logo" className="h-8 w-auto light-logo" />
            <img src="/logo-white.png" alt="Logo" className="h-8 w-auto dark-logo" />
          </Link>
          <p className="text-text-secondary text-xs leading-relaxed max-w-xs">
            Autonomous logistics command center and procurement matching suite for modern high-frequency supply chain networks.
          </p>
        </div>

        <div>
          <h4 className="text-[10px] font-bold text-text-primary tracking-widest uppercase mb-4 font-title">Product</h4>
          <ul className="text-xs text-text-secondary flex flex-col gap-3">
            <li><Link to="/features" className={getLinkClass("/features")}>Features</Link></li>
            <li><Link to="/pricing" className={getLinkClass("/pricing")}>Pricing</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[10px] font-bold text-text-primary tracking-widest uppercase mb-4 font-title">Company</h4>
          <ul className="text-xs text-text-secondary flex flex-col gap-3">
            <li><Link to="/about" className={getLinkClass("/about")}>About Us</Link></li>
            <li><Link to="/contact" className={getLinkClass("/contact")}>Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[10px] font-bold text-text-primary tracking-widest uppercase mb-4 font-title">Legal</h4>
          <ul className="text-xs text-text-secondary flex flex-col gap-3">
            <li><Link to="/terms-of-service" className="hover:text-brand-orange transition-colors">Terms of Service</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-brand-orange transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-8 border-t border-border-theme/40 flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="text-[10px] text-text-muted">
          © {new Date().getFullYear()} Supply Spot. All rights reserved. Savic technologies private limited.
        </div>
        <div className="flex gap-4 items-center">
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-brand-orange hover:scale-110 active:scale-95 transition-all">
            <FaLinkedin className="w-4 h-4" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-brand-orange hover:scale-110 active:scale-95 transition-all">
            <FaInstagram className="w-4 h-4" />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-brand-orange hover:scale-110 active:scale-95 transition-all">
            <FaXTwitter className="w-4 h-4" />
          </a>
        </div>
      </div>
    </footer>
  );
}
